import { Command } from './Command';

function SetUserDataValue( editor, object, attribute, newValue, delayAutoSave) {
    Command.call(this, editor);

    this.type = 'SetUserDataValue';
    this.name = `Set User Data ${attribute}`;
    this.updatable = true;

    this.object = object;
    this.attribute = attribute;
    this.oldValue = object !== undefined ? object.userData[attribute] : undefined;
    this.name = object !== undefined ? object.name : undefined;
    this.newValue = newValue;
    this.delayAutoSave = delayAutoSave;

}

SetUserDataValue.prototype = {
    execute: function() {
        this.object.userData[this.attribute] = this.newValue;
        this.editor.trigger('objectChanged', [this.object, this.delayAutoSave, this.name ])
    },

    undo: function() {
        this.object.userData[this.attribute] = this.oldValue;
        this.editor.trigger('objectChanged', [this.object, this.delayAutoSave, this.name ])
    },

    update: function(command) {
        this.newValue = command.newValue;
    },

    toJSON: function() {
        var output = Command.prototype.toJSON.call(this);

        output.objectUuid = this.object.uuid;
        output.oldValue = this.oldValue;
        output.newValue = this.newValue;
        output.attribute = this.attribute;
        output.delayAutoSave = this.delayAutoSave;


        return output;
    }
}

export { SetUserDataValue };